import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no item open
export const Route = createFileRoute('/_authenticated/teams/tennisPlayers/')({});
